import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const navigationLinks = [
    { path: '/homepage', label: 'Home' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' },
    { path: '/technical-blog', label: 'Blog' }
  ];

  const socialLinks = [
    { icon: 'Github', url: 'https://github.com', label: 'GitHub' },
    { icon: 'Linkedin', url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: 'Twitter', url: 'https://twitter.com', label: 'Twitter' },
    { icon: 'Mail', url: 'mailto:mikeoforka7@gmail.com', label: 'Email' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <Link to="/homepage" className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
                <Icon name="Code2" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-bold font-heading text-foreground">
                Mr Mike Technologies
              </span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Full Stack Software Developer delivering robust, scalable, and innovative solutions for startups and enterprises. Bridging technical expertise with business value at Mr Mike Technologies.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground mb-4 uppercase tracking-wider">
              Navigation
            </h3>
            <ul className="space-y-2">
              {navigationLinks?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground mb-4 uppercase tracking-wider">
              Services
            </h3>
            <ul className="space-y-2">
              <li>
                <span className="text-sm text-muted-foreground">
                  Full-Stack Development
                </span>
              </li>
              <li>
                <span className="text-sm text-muted-foreground">
                  System Architecture
                </span>
              </li>
              <li>
                <span className="text-sm text-muted-foreground">
                  Performance Optimization
                </span>
              </li>
              <li>
                <span className="text-sm text-muted-foreground">
                  Technical Consulting
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold font-heading text-foreground mb-4 uppercase tracking-wider">
              Connect
            </h3>
            <div className="flex gap-3 mb-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:-translate-y-1"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
            <div className="space-y-2">
              <a
                href="mailto:mikeoforka7@gmail.com"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                <Icon name="Mail" size={16} />
                <span>mikeoforka7@gmail.com</span>
              </a>
              <div className="flex items-center gap-2 text-sm text-success">
                <div className="w-2 h-2 rounded-full bg-success animate-pulse-glow" />
                <span className="font-medium">Available for projects</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Mr Mike Technologies. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;